/**
 * @module app.ext.mcg-informed
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IAssessmentsConfig } from 'app/core/models/essette-interfaces';
import { AssessmentService } from 'app/core/services/assessment-service';
import { CasePageContext } from 'app/cm/lib/case-page-context';
import * as CD from 'app/cd/models/essette-api';
import { IAssessmentAttachmentOptions } from 'app/ext/mcg-informed/assessment-attachment';


@autoinject()
export class Assessment extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected attachmentId: string | null = null;
    protected readonly: boolean = false;

    protected assessmentConfig: IAssessmentsConfig = {
        serviceRootUrl: 'cm/cases',
        targetType: 'CM.Case',
        backRouteName: 'cm.case.assessments'
    };

    protected target: Readonly<{
        id: string | null;
        number: string | null;
        member: CD.Member | null;
    }> | null = null;

    protected options: IAssessmentAttachmentOptions = {
        showToc: true,
        showBack: true,
        showActions: true,
        showMember: true,
        showMemberSummaryLink: false,
        showTarget: true,
        showTargetSummaryLink: false,
        stickyActions: true
    };

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AssessmentService,
        private readonly context: CasePageContext,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: { caseId: string, attachmentId: string }): Promise<void> {
        if(!params.attachmentId) { throw new Error("Invalid or missing parameter [attachmentId]"); }

        this.service.configure(this.assessmentConfig);
        this.attachmentId = params.attachmentId;

        const includes = ['member'];
        const fields = ['member.description', 'member.name.full', 'number'];
        await this.context.loadCase(params.caseId, includes, fields);

        if(this.context.isCaseLoaded) {
            this.target = {
                id: this.context.case.id || null,
                number: this.context.case.number || null,
                member: this.context.case.member || null
            };
            this.checkPermissions();
        }
        // If still missing target information, do not display member nor target labels
        else {
            this.options.showMember = false;
            this.options.showTarget = false;
        }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.options.showTargetSummaryLink = this.accountContext.hasRouteAccess('cm.case.summary');
        if(!!this.target?.member) {
            this.options.showMemberSummaryLink = this.accountContext.hasRouteAccess('cd.member.summary');
        }
    }


    ////****************** Service Calls ********************************************////

}
